import { isNotDefined } from '@sgme/fp';
import { useIntl } from 'react-intl';

interface Options {
  min?: number;
  max?: number;

  unit?: string;
}
export function useMinMaxText({ min, max, unit }: Options) {
  const { formatMessage } = useIntl();
  if (isNotDefined(min) || isNotDefined(max)) {
    return undefined;
  }
  return formatMessage({ id: 'input.rangePlaceholder' }, { min, max, unit: unit });
}
